<template>
  <div class="project-members-popover-container">
    <el-popover trigger="click" @hide="handleMembersHide" v-model="show">
      <div class="project-set-members-box">
        <Members
          :isTask="isTask"
          :id="id"
          :num="membersLength"
          :isHide="isHide"
          :membersUidArr="membersUidArr"
          :membersDataList="membersDataList"
          :addOrDelPermission="addOrDelPermission"
          :setAdminPermission="setAdminPermission"
          @handleSearchMember="handleSearchMember"
          :show="show"
        ></Members>
      </div>
      <div class="members-wrap" slot="reference">
        <ul>
          <li v-for="item of membersArr.slice(0, 5)" :key="item.uid">
            <Myavatar
              width="28px"
              height="28px"
              fontSize="12px"
              :imgUrl="item.user_avatar"
              :userName="item.realname"
            ></Myavatar>
          </li>
        </ul>
        <i class="icon iconfont iconicon_enlarge" v-if="addOrDelPermission && !isDisabledProject"></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
import Members from './components/members.vue'
import { mapState } from 'vuex'
import bus from '@/bus'
export default {
  props: {
    // 是否为项目页面引用
    isTask: {
      type: Boolean,
      default: false
    },
    // 成员浮窗是否关闭
    isHide: {
      type: Boolean,
      default: false
    },
    // 项目id
    id: {
      type: Number,
      default: null
    },
    // 项目成员数据数组
    membersArr: {
      type: Array,
      default: () => [ ]
    },
    // 项目成员uid组成的数组
    membersUidArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 项目所有成员的数量
    membersLength: {
      type: Number,
      default: 0
    },
    // 项目成员集合对象，包括部门名称 ('部门名称: [项目成员]'这样的对象模式)
    membersDataList: {
      type: Object,
      default: () => { }
    },
    // 添加成员的权限
    addOrDelPermission: {
      type: Boolean,
      default: false
    },
    // 设置管理员的权限
    setAdminPermission: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Members
  },
  computed: {
    ...mapState('task/task', {
      isDisabledProject: state => state.isDisabledProject
    })
  },
  created() {
    bus.$on('openProjectMember', () => {
      this.show = true
    })
  },
  destroyed() {
    bus.$off('openProjectMember')
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    handleMembersHide() {
      this.$emit('handleMembersHide')
    },
    // 搜索成员
    handleSearchMember(keywords, needInit) {
      this.$emit('handleSearchMember', keywords, needInit)
    }
  },
}
</script>

<style lang="scss" scoped>
.members-wrap {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  ul {
    display: flex;
    li {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #FFFFFF;
      margin-right: -8px;
    }
  }
  .iconicon_enlarge {
    z-index: 99;
    font-size: 12px;
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    background: #fff;
    border-radius: 50%;
    border: 1px solid #E5E6E8;
    &:hover {
      background: #ECECEC;
    }
    &:active {
      background: #DADADA;
    }
  }
}
</style>
